import React, { useState, useEffect, useRef } from 'react'
import './BucksCharts.css'
//components
import DashboardFilter from '../fragments/DashboardFilter'
import SubcategoriesTable from '../../../components/SubcategoriesTable/SubcategoriesTable'
import Bar from '../../../components/Charts/Bar/Bar'
import Donut from '../../../components/Charts/Donut/Donut'
//services
import { dashboardService } from '../../../services/Dashboard';
//utils
import { formatShortDate, getMonth } from '../../../utils/utils';
import HeaderSection from '../../../components/PdfDownload/Header'

const BucksCharts = () => {
  const chartRef = useRef(null);
  const hiddenRef = useRef(null);
  const customColors = ['#15B79E', '#0E5F79', '#F2994A'];
  const [bucksTransfer, setBucksTransfer] = useState([]);
  const [numberBucks, setNumberBucks] = useState([]);
  const [totalNumberBucks, setTotalNumberBucks] = useState(0);
  const [recentlyMovements, setRecentlyMovements] = useState([]);
  const [gainsRegion, setGainsRegion] = useState([]);
  const [reportRange, setReportRange] = useState({ start: null, end: null });

  useEffect(() => {
    fetchBucksTransfer();
    fetchNumberBucks();
    fetchRecentlyMovements();
    fetchGainsRegion();
  }, []);

  const fetchBucksTransfer = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      setReportRange({ start: start_date, end: end_date });
      const response = await dashboardService.bucksTransfer(params);
      if (response && response.series && response.series[0] && response.series[0].data.length > 0) {
        const data = response.series[0].data.map(item => ({
          x: item.x,
          y: item.y
        }));
        setBucksTransfer(data);
      }
    } catch (error) {
      console.error('Error fetching bucks transfer:', error);
    }
  };

  const fetchNumberBucks = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.numberBucks(params);
      if (response && response.series && response.series[0] && response.series[0].data.length > 0) {
        const data = response.series[0].data.map(item => ({
          x: item.label == "Tokens Obtenidos" ? "Tokens Earned" : "Tokens Spent",
          y: item.percentage
        }));
        setNumberBucks(data);
        setTotalNumberBucks(response.total);
      }
    } catch (error) {
      console.error('Error fetching number bucks:', error);
    }
  };

  const fetchRecentlyMovements = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        limit: 10,
        offset: 0,
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.bucksMovements(params);
      if (response && response.data && response.data.length > 0) {
        setRecentlyMovements(response.data);
      } else {
        setRecentlyMovements([]);
      }
    } catch (error) {
      console.error('Error fetching bucks movements:', error);
    }
  };

  const fetchGainsRegion = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.bucksGainsRegion(params);
      if (response && response.series && response.series.length > 0) {
        const data = response.series.map(item => ({
          name: item.label,
          data: item.data
        }));
        setGainsRegion(data);
      }
    } catch (error) {
      console.error('Error fetching bucks gains region:', error);
    }
  };

  return (
    <>
      <div className="packages-charts-container">
        <DashboardFilter
          chartRef={hiddenRef}
          onApplyFilters={(filters) => {
            fetchBucksTransfer(filters);
            fetchRecentlyMovements(filters);
            fetchNumberBucks(filters);
          }}
          dynamicHeight={true}
        />
        <div className="chart-wrapper" ref={chartRef}>
          <Bar
            series={[
              {
                data: bucksTransfer,
                name: 'barter bucks'
              }
            ]}
            title="Barter bucks transfer"
            height={170}
            width={400}
            colors={customColors}
          />
          <Donut
            data={numberBucks}
            isTotal={true}
            total={totalNumberBucks}
            title="Number of barter bucks transfered"
            height={170}
            width={400}
            innerRadius={40}
            outerRadius={80}
            colors={customColors}
          />
        </div>
        <SubcategoriesTable
          title="Recent movements"
          data={recentlyMovements}
          columns={[
            { header: 'Folio', field: 'id' },
            { header: 'Transmitter', field: 'transaction_type' },
            { header: 'Receiver', field: 'user' },
            { header: 'Barter Bucks', field: 'tokens' },
            { header: 'Movement', field: 'date' },
            { header: 'Region', field: 'region' },
          ]}
        />
        <Bar
          series={gainsRegion}
          title="Gains by region"
          height={170}
          width={1000}
          widthContainer="97%"
          heightContainer="90%"
          colors={customColors}
        />
      </div>

      {/* Bloque oculto solo para PDF */}
      <div ref={hiddenRef} className="hidden-container">
        <HeaderSection
          title="Barter Bucks"
          date={formatShortDate(new Date(), '-')}
          period={
            reportRange.start && reportRange.end
              ? `${reportRange.start} - ${reportRange.end}`
              : 'Sin fecha'
          }
        />
        <div className="chart-wrapper">
          <Bar
            series={[
              {
                data: bucksTransfer,
                name: 'barter bucks'
              }
            ]}
            title="Barter bucks transfer"
            height={170}
            width={400}
            colors={customColors}
          />
          <Donut
            data={numberBucks}
            isTotal={true}
            total={totalNumberBucks}
            title="Number of barter bucks transfered"
            height={170}
            width={400}
            innerRadius={40}
            outerRadius={80}
            colors={customColors}
          />
        </div>
        <SubcategoriesTable
          title="Recent movements"
          data={recentlyMovements}
          columns={[
            { header: 'Folio', field: 'id' },
            { header: 'Transmitter', field: 'transaction_type' },
            { header: 'Receiver', field: 'user' },
            { header: 'Barter Bucks', field: 'tokens' },
            { header: 'Movement', field: 'date' },
            { header: 'Region', field: 'region' },
          ]}
          tableHeight="110vh"
        />
        <Bar
          series={gainsRegion}
          title="Gains by region"
          height={170}
          width={1000}
          widthContainer="97%"
          heightContainer="90%"
          colors={customColors}
        />
      </div>
    </>
  )
}

export default BucksCharts
